// noinspection JSUnresolvedReference

/*
 * findUserByEmail: This function will search a user by email address and returns the object.
 *
 * If the user is found, it will return the user's information.
 * If the user isn't found or an error occurs, it will return an error message.
 */
import makeRequest from "../api/apiRequest";
import { constructUrl } from "./apiConfig";
import apiClient from "./apiClient";

export const findUserByEmail = async (email) => {
  const endpoint = `/user?user=${email}`;
  const url = constructUrl(endpoint);
  const response = await makeRequest(url, "GET", null, {}, {});

  if (response.errorType === 0) {
    // Request success and data exists
    return {
      userInfo: response.data,
      errorMsg: null,
    };
  } else {
    console.log(
      `findUserByEmail: response.errorMessage= ${JSON.stringify(
        response.errorMessage
      )}`
    );
    return {
      userInfo: null,
      errorMsg: response.errorMessage,
    };
  }
};

export const findGIDByUsername = async (username) => {
  const endpoint = `/gid?user=${username}`;
  const url = constructUrl(endpoint);
  const response = await makeRequest(url, "GET", null, {}, {});

  if (response.errorType === 0) {
    // Request success and data exists
    return {
      userInfo: response.data,
      errorMsg: null,
    };
  } else {
    console.log(
      `findUserByUsername: response.errorMessage= ${JSON.stringify(
        response.errorMessage
      )}`
    );
    return {
      userInfo: null,
      errorMsg: response.errorMessage,
    };
  }
};

export const unlockAccount = async (userId) => {
  const endpoint = "/unlock_account";
  const url = constructUrl(endpoint);
  console.log(`unlockAccount: url= ${url}, userid= ${userId}`);
  const response = await makeRequest(url, "Post", { userid: userId }, {}, {});
  console.log(`unlockAccount: response.errorType= ${response.errorType}`);

  if (response.errorType === 0) {
    return {
      errorMsg: null,
    };
  } else {
    return { errorMsg: response.errorMessage };
  }
};

export const unlockGID = async (username) => {
  const endpoint = "/unlock_gid";
  const url = constructUrl(endpoint);
  console.log(`unlockGID: url= ${url}, username= ${username}`);
  const response = await makeRequest(url, "Post", { username: username }, {}, {});
  console.log(`unlockGID: response.errorType= ${response.errorType}`);

  if (response.errorType === 0) {
    return {
      errorMsg: null,
    };
  } else {
    return { errorMsg: response.errorMessage };
  }
};

export const addToMfaPilot = async (userId) => {
  const endpoint = "/add_to_mfa_pilot";
  const url = constructUrl(endpoint);
  console.log(`addToMfaPilot: url= ${url}, user_id= ${userId}`);
  const response = await makeRequest(url, "Post", { userid: userId }, {}, {});
  console.log(`addToMfaPilot: response.errorType= ${response.errorType}`);

  if (response.errorType === 0) {
    return {
      data: response.data,
      errorMsg: null,
    };
  } else {
    return { errorMsg: response.errorMessage };
  }
};

export const startOffNetworkEnrollment = async (userId) => {
  const url = import.meta.env.VITE_OFF_NETWORK_ENROLLMENT_URL || import.meta.env.REACT_APP_OFF_NETWORK_ENROLLMENT_URL;
  console.log(`startOffNetworkEnrollment: url= ${url}, user_id= ${userId}`);
  
  try {
    const response = await apiClient.post(url, { user_id: userId });
    console.log(`startOffNetworkEnrollment: success, data= ${JSON.stringify(response.data)}`);
    return {
      data: response.data,
      errorMsg: null,
    };
  } catch (error) {
    console.log(`startOffNetworkEnrollment: error= ${error.message}`);
    const errorMsg = error.response?.data?.message || error.message || "Network error occurred";
    return {
      data: null,
      errorMsg: errorMsg,
    };
  }
};